import { Slot, router, useGlobalSearchParams } from 'expo-router';
import { anonymousRegisterStringForStore, registrationCodeStringForStore } from '../../constants/storageKeys';
import { concatPath } from '../../utils/links/concatPath';
import { loginKey } from '../../constants/routeKeys';
import { publicKey, reckoningIdStorageKey, reckoningSessionIdStorageKey } from '../../constants/routeKeys';
import { saveString } from '../../utils/storage';
import { useCreateAnonymousUser } from '../../hooks/authentification/useCreateAnonymousUser';
import { useEffect } from 'react';
import { useLogout } from '../../hooks/authentification/useLogout';
import { useSilentLogin } from '../../hooks/authentification/useSilentLogin';
import { useStores } from '../../hooks/useStores';




export default function Layout() {

  const params = useGlobalSearchParams();

  const rootStore = useStores();

  const {modalNeedRedirection, modalNotAvailable, canBeCreated} = useCreateAnonymousUser(params.reckoningId as string);
  const logout = useLogout(() => { });

  useSilentLogin({setInitLogin : () => {}, logout, ignoreIfNoToken: true});

  const hasUser = !!rootStore.user.user;
  const isAnon = !!rootStore.user.anonymous;

  useEffect(() => {

    if(params && registrationCodeStringForStore in params) {
      saveString(registrationCodeStringForStore,params[registrationCodeStringForStore] as string);
    }
    if(params && reckoningIdStorageKey in params) {
      saveString(reckoningIdStorageKey,params[reckoningIdStorageKey] as string);
    }
    if(params && reckoningSessionIdStorageKey in params) {
      saveString(reckoningSessionIdStorageKey,params[reckoningSessionIdStorageKey] as string);
    }
  }, [params]);


  useEffect(() => {
    console.log('hasUser',hasUser, 'isAnon', isAnon);
    if(hasUser) {
      if(isAnon && params && anonymousRegisterStringForStore in params) {
        saveString(anonymousRegisterStringForStore,params.anonymousRegister as string);
      }
    } else if(!canBeCreated){
      router.navigate(concatPath([publicKey,loginKey]) as string);
    }
  }, [isAnon, canBeCreated]);



  return(
    <>
      {modalNeedRedirection()}
      {modalNotAvailable()}
      <Slot />
    </>
  );
}